import Flex from '@deprecated-ui/common/Flex';
import IconMoreOptions from '@deprecated-ui/common/IconMoreOptions';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Popover from '@deprecated-ui/common/Popover';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors as credentialSelectors } from 'lib/entities/credentials';
import { ModalBlockUser, ModalSuspendUser } from 'global/Moderation/Modals';
import {
  getUserRole,
  isAllowedToManageTop,
  UserRoleName,
} from 'utils/userRole';
import auth from 'utils/auth';
import Link from 'next/link';
import { copyTextToClipboard } from 'utils/general';
import { PROJECT_FOLDER } from 'constants/app';
import alertMessage from 'global/AlertMessage';
import If from 'global/ErrorHandlers/If';
import SUCCESS_MESSAGE from 'constants/successMessage';
import IconBell from 'assets/customIcon/stream-icon/IconBell';
import IconBellActive from 'assets/customIcon/stream-icon/IconBellActive';
import { ModalReport, ModalDeleteAdmin, ModalDeleteAuthor } from '../Modals';
import OptionItem from './OptionItem';
import { effects } from '../slice';
import ModalEditPost from '../Modals/ModalEditPost';
import { StreamPostData } from '../../../../@types/stream';
import {
  NotifText,
  StreamOptionContainer,
  StreamOptionDivider,
  IconStyle,
  BadgeJunkWrapper,
} from './styled';
import PopoverChangeCommenter from './PopoverChangeCommenter';
import { StreamEntryPoint } from '../types';
import {
  DATA_CY_POST_STREAM_ITEM_OPTION,
  DATA_CY_STREAM_ITEM_OPTION_BUTTON,
  DATA_CY_STREAM_ITEM_OPTION_BUTTON_COMPANY,
} from './__tests__/constants';
import WarningBadge from './WarningBadge';

interface StreamItemOptionProps {
  saved: number | boolean;
  followed: number | boolean;
  postId: number;
  userId: number;
  post: StreamPostData;
  showFollowNotification: boolean;
  isPolling?: boolean;
  type?: 'post' | 'comment';
  entryPoint?: StreamEntryPoint;
  showDeleteAsAuthor?: boolean;
  handleCloseConvo?: () => void;
  symbol?: string;
  isViolation?: boolean;
}

function StreamItemOption({
  post,
  userId = 0,
  postId = 0,
  saved = false,
  followed = false,
  showFollowNotification = false,
  isPolling = false,
  symbol = '',
  type,
  entryPoint,
  showDeleteAsAuthor = false,
  handleCloseConvo,
  isViolation = false,
}: StreamItemOptionProps) {
  const dispatch = useDispatch();

  const [modalDelete, showModalDelete] = useState<boolean>(false);
  const [modalDeleteMultiple, showModalDeleteMultiple] =
    useState<boolean>(false);
  const [modalDeleteAuthor, showModalDeleteAuthor] = useState(false);
  const [modalReport, showModalReport] = useState<boolean>(false);
  const [modalEdit, showModalEdit] = useState<boolean>(false);
  const [modalBlock, showModalBlock] = useState<boolean>(false);
  const [modalSuspend, showModalSuspend] = useState<boolean>(false);
  const [menuPopover, showMenuPopover] = useState(false);
  const [popoverCommenter, showPopoverCommenter] = useState(false);
  const [modalWarning, setModalWarning] = useState(false);

  const isAuthor = post.is_author > 0;

  // @ts-ignore
  const privilege = auth.getUserAccess()?.privilege;
  const isMyRoleAdmin = getUserRole(privilege) === UserRoleName.ADMIN;
  const isAdminPost = getUserRole(post.user_priv) === UserRoleName.ADMIN;

  const isShowMuted = isMyRoleAdmin && !isAuthor && !isAdminPost;
  const isShowEdit = isAuthor && !isPolling;
  const isPinned = post.ispinned;
  const isShowDeletePostAdmin = isMyRoleAdmin ? !isAdminPost : false;
  const isShowDeleteMultiple = isMyRoleAdmin
    ? (!isAdminPost || isAuthor) && entryPoint !== 'conversation'
    : false;
  const isShowUntag = isMyRoleAdmin
    ? entryPoint !== 'conversation' && isAllowedToManageTop(privilege)
    : false;
  const isShowPinUnpin =
    isAuthor && entryPoint !== 'stream' && entryPoint !== 'conversation';

  // TODO: Handle follow (DONE), handle save post (DONE), handle pin (if necessary)
  const handleToggleFollow = () => {
    const action = followed ? effects.unfollowPost : effects.followPost;
    // @ts-ignore
    dispatch(action(postId));
  };

  const handleToggleSave = () => {
    const action = saved ? effects.unsavePost : effects.savePost;
    // @ts-ignore
    dispatch(action(postId));
  };

  const handleTogglePin = () => {
    const action = post.ispinned ? effects.unpinPost : effects.pinPost;
    const data = {
      postid: postId,
      // TODO: handle if there is symbol
    };
    // @ts-ignore
    dispatch(action(data));
  };

  const handleReportPost = async (val) => {
    const data = {
      postid: postId,
      ...val,
    };
    // @ts-ignore
    const report = await dispatch(effects.postReportStream(data));

    // @ts-ignore
    const { error } = report?.payload ?? {};

    if (!error) {
      showModalReport(false);
      setModalWarning(false);
      alertMessage({
        content: SUCCESS_MESSAGE.REPORT_DELIVERED,
        alertType: 'snackbar',
        messageType: 'success',
        hasCloseIcon: false,
      });
    }
  };

  const handleDeletePost = async (val?: any) => {
    const data = {
      ...val,
      sendEmail: val.sendEmail,
      postid: postId,
      isAuthor: isAuthor && isMyRoleAdmin ? false : isAuthor,
      type,
    };
    // @ts-ignore
    const deletePost = await dispatch(effects.deleteStreamPost(data));

    // @ts-ignore
    const { error } = deletePost.payload;
    if (!error) {
      showModalDelete(false);
      showModalDeleteAuthor(false);

      if (handleCloseConvo) {
        handleCloseConvo();
      }
    }
  };

  const handleDeleteMultiplePost = async (val) => {
    const data = {
      ...val,
      sendEmail: val.sendEmail,
      userid: userId,
    };

    // @ts-ignore
    const deletePost = await dispatch(effects.deleteMultipleStreamPost(data));
    // @ts-ignore
    const { error } = deletePost.payload;
    if (!error) {
      showModalDeleteMultiple(false);
    }
  };

  const handleUntagPost = () => {
    // @ts-ignore
    dispatch(effects.untagPost(postId));
  };

  const handleCopyLink = () => {
    const path =
      !PROJECT_FOLDER || PROJECT_FOLDER === '/' ? '/' : `/${PROJECT_FOLDER}/`;
    const copiedLink = `${window.location.origin}${path}post/${post.postid}`;
    copyTextToClipboard(
      copiedLink,
      () =>
        alertMessage({
          content: 'Link copied',
          alertType: 'snackbar',
          messageType: 'success',
          hasCloseIcon: true,
        }),
      // eslint-disable-next-line function-paren-newline
    );
    showMenuPopover(false);
  };

  const handleChangeCommenterType = async (commenterType, label) => {
    await dispatch(
      effects.changeCommenter({
        type: commenterType,
        postid: postId,
        label,
      }),
    );
  };

  const { isLoggedIn } = useSelector(credentialSelectors);

  if (!isLoggedIn) {
    return (
      <Flex align="center" className={DATA_CY_POST_STREAM_ITEM_OPTION}>
        <Link href="/register">
          <a>
            <IconMoreOptions />
          </a>
        </Link>
      </Flex>
    );
  }

  const showCommenterPopover = () => {
    showPopoverCommenter(true);
    showMenuPopover(false);
  };

  const hasMention =
    Array.isArray(post.mask_html) &&
    post.mask_html.some((mask) => mask.text.indexOf('@') > -1);
  const hasCommenter =
    isAuthor &&
    (post.parent_postid === 0 || post.postid === post.parent_postid);
  const containerId = `stream-option-${entryPoint}-${post.postid}`;
  const popoverId = `${containerId}-popover`;

  return (
    <>
      <div id={containerId} />
      <div id={popoverId} />
      <Flex
        align="center"
        style={{ position: 'relative' }}
        className={DATA_CY_POST_STREAM_ITEM_OPTION}
      >
        <If condition={showFollowNotification}>
          <Flex
            // @ts-expect-error
            mr="8px"
            style={{ cursor: 'pointer' }}
            onClick={handleToggleFollow}
            align="center"
          >
            <IconWrapper size="14px">
              <IconStyle>
                {followed ? <IconBellActive /> : <IconBell />}
              </IconStyle>
            </IconWrapper>
            <NotifText>Turn {followed ? 'Off' : 'On'} Notification</NotifText>
          </Flex>
        </If>
        <BadgeJunkWrapper>
          <WarningBadge
            visible={isViolation}
            modalReport={modalReport}
            showModalReport={showModalReport}
            modalWarning={modalWarning}
            setModalWarning={setModalWarning}
          />
        </BadgeJunkWrapper>

        <Popover
          trigger={['contextMenu', 'click']}
          placement="bottomRight"
          getPopupContainer={() => document.getElementById(containerId)}
          overlayStyle={{ minWidth: '145px', paddingTop: 0 }}
          visible={menuPopover}
          onVisibleChange={(visible: boolean) => showMenuPopover(visible)}
          zIndex={entryPoint !== 'conversation' ? 20 : undefined}
          autoAdjustOverflow
          content={() => (
            <StreamOptionContainer>
              <OptionItem
                iconName="save"
                isActive={saved}
                onClick={handleToggleSave}
                data-cy="stream-item-option-save"
              >
                {saved ? 'Saved' : 'Save'}
              </OptionItem>

              <If condition={!showFollowNotification}>
                <OptionItem
                  iconName="follow"
                  isActive={followed}
                  onClick={handleToggleFollow}
                  data-cy="stream-item-option-follow"
                >
                  {followed ? 'Unfollow' : 'Follow'} this Post
                </OptionItem>
              </If>

              <If condition={isShowPinUnpin}>
                <OptionItem
                  iconName="pin"
                  isActive={isPinned}
                  onClick={handleTogglePin}
                  data-cy="stream-item-option-pin"
                >
                  {isPinned ? 'Unpin' : 'Pin'} this Post
                </OptionItem>
              </If>

              <If
                condition={
                  isShowEdit || isAuthor || (isMyRoleAdmin && !isAdminPost)
                }
              >
                <StreamOptionDivider />
              </If>

              <If condition={isShowEdit}>
                <OptionItem
                  iconName="edit"
                  onClick={() => showModalEdit(true)}
                  data-cy="stream-item-option-edit"
                >
                  Edit post
                </OptionItem>
              </If>

              <If condition={hasCommenter}>
                <OptionItem
                  iconName="comment"
                  onClick={showCommenterPopover}
                  data-cy="stream-item-option-who-can-comment"
                >
                  Change Who Can Comment
                </OptionItem>
              </If>

              <If condition={isAuthor}>
                <OptionItem
                  iconName="delete"
                  onClick={() => showModalDeleteAuthor(true)}
                  data-cy="stream-item-option-delete-author"
                >
                  Delete {type}
                </OptionItem>
              </If>

              <If condition={isShowDeletePostAdmin}>
                <OptionItem
                  iconName="delete"
                  onClick={() => showModalDelete(true)}
                  data-cy="stream-item-option-delete-admin"
                >
                  Delete {type}
                </OptionItem>
              </If>

              <If condition={isShowDeleteMultiple}>
                <OptionItem
                  iconName="delete-multiple"
                  onClick={() => showModalDeleteMultiple(true)}
                  data-cy="stream-item-option-delete-multiple"
                >
                  Delete Multiple
                </OptionItem>
              </If>

              <StreamOptionDivider />

              <If condition={isShowUntag}>
                <OptionItem
                  iconName="untag"
                  onClick={handleUntagPost}
                  data-cy="stream-item-option-untag"
                >
                  Untag Post Topic
                </OptionItem>
              </If>

              <If condition={isShowMuted && entryPoint !== 'conversation'}>
                <OptionItem
                  iconName="mute"
                  onClick={() => showModalSuspend(true)}
                  data-cy="stream-item-option-mute"
                >
                  Mute user
                </OptionItem>
              </If>

              <If condition={!isAuthor && !isAdminPost}>
                <OptionItem
                  iconName="block"
                  onClick={() => showModalBlock(true)}
                  data-cy="stream-item-option-block"
                >
                  Block user
                </OptionItem>
              </If>

              <OptionItem
                iconName="report"
                onClick={() => showModalReport(true)}
                data-cy="stream-item-option-report"
              >
                Report Abuse
              </OptionItem>

              <OptionItem
                iconName="link"
                onClick={handleCopyLink}
                data-cy="stream-item-option-copy"
              >
                Copy Link
              </OptionItem>
            </StreamOptionContainer>
          )}
        >
          <IconMoreOptions
            data-cy={
              symbol
                ? DATA_CY_STREAM_ITEM_OPTION_BUTTON_COMPANY
                : DATA_CY_STREAM_ITEM_OPTION_BUTTON
            }
            onClick={() => showMenuPopover(!menuPopover)}
          />
        </Popover>
      </Flex>
      <PopoverChangeCommenter
        visible={popoverCommenter}
        hasMention={hasMention}
        defaultCommenterType={post.commenter_type}
        popoverId={popoverId}
        onChange={handleChangeCommenterType}
        onCancel={(visible) => showPopoverCommenter(visible)}
      />

      {/* Modals */}
      <ModalDeleteAuthor
        visible={modalDeleteAuthor}
        handleDelete={handleDeletePost}
        onCancel={() => showModalDeleteAuthor(false)}
        type="post"
      />
      <ModalDeleteAdmin
        visible={modalDelete}
        onDelete={handleDeletePost}
        onCancel={() => showModalDelete(false)}
        isAdmin={isMyRoleAdmin}
        type={type}
      />
      <ModalDeleteAdmin
        multiple
        visible={modalDeleteMultiple}
        onDelete={handleDeleteMultiplePost}
        onCancel={() => showModalDeleteMultiple(false)}
      />
      <ModalReport
        visible={modalReport}
        destroyOnClose
        onReport={handleReportPost}
        onCancel={() => showModalReport(false)}
      />
      <ModalEditPost
        visible={modalEdit}
        post={post}
        onCancel={() => showModalEdit(false)}
      />
      <ModalBlockUser
        visible={modalBlock}
        userId={userId}
        username={post.username}
        onCancel={() => showModalBlock(false)}
      />
      <ModalSuspendUser
        visible={modalSuspend}
        username={post.username}
        userId={userId}
        postId={postId}
        onCancel={() => showModalSuspend(false)}
        onSubmit={() => setModalWarning(false)}
      />
    </>
  );
}

export default StreamItemOption;
